// СГЕНЕРИРОВАНО yarn tokens. Не редактировать руками.

export const tokens = {
  colors: {
    bg: 'var(--color-bg)',
    bgDeep: 'var(--color-bg-deep)',
    surface: 'var(--color-surface)',
    surfaceAlt: 'var(--color-surface-alt)',
    surfaceSoft: 'var(--color-surface-soft)',
    controlDisabled: 'var(--color-control-disabled)',
    surfaceBlur: 'var(--color-surface-blur)',
    divider: 'var(--color-divider)',
    overlay: 'var(--color-overlay)',
    overlayStrong: 'var(--color-overlay-strong)',
    text: 'var(--color-text)',
    textStrong: 'var(--color-text-strong)',
    textSecondary: 'var(--color-text-secondary)',
    textMuted: 'var(--color-text-muted)',
    textDim: 'var(--color-text-dim)',
    textOnAccent: 'var(--color-text-on-accent)',
    textOnSurfaceAlt: 'var(--color-text-on-surface-alt)',
    accent: 'var(--color-accent)',
    accentDeep: 'var(--color-accent-deep)',
    accentSoft: 'var(--color-accent-soft)',
    accentWash: 'var(--color-accent-wash)',
    accentWashStrong: 'var(--color-accent-wash-strong)',
    borderAccentSoft: 'var(--color-border-accent-soft)',
    success: 'var(--color-success)',
    successWash: 'var(--color-success-wash)',
    successDeep: 'var(--color-success-deep)',
    error: 'var(--color-error)',
    errorWash: 'var(--color-error-wash)',
    errorWashStrong: 'var(--color-error-wash-strong)',
    errorText: 'var(--color-error-text)',
    notificationError: 'var(--color-notification-error)',
    notificationWarning: 'var(--color-notification-warning)',
    notificationSuccess: 'var(--color-notification-success)',
    notificationInfo: 'var(--color-notification-info)',
    compliment: 'var(--color-compliment)',
    complimentText: 'var(--color-compliment-text)',
    glowViolet: 'var(--color-glow-violet)',
    glowWarm: 'var(--color-glow-warm)',
  },
  gradients: {
    accent: 'var(--gradient-accent)',
    headerScrim: 'var(--gradient-header-scrim)',
  },
  glows: {
    me: 'var(--glow-me)',
    near: 'var(--glow-near)',
    mid: 'var(--glow-mid)',
    far: 'var(--glow-far)',
    beacon: 'var(--glow-beacon)',
    shine: 'var(--glow-shine)',
    resultCard: 'var(--glow-result-card)',
  },
  shadows: {
    card: 'var(--shadow-card)',
    menu: 'var(--shadow-menu)',
    sheet: 'var(--shadow-sheet)',
    compliment: 'var(--shadow-compliment)',
    accent: 'var(--shadow-accent)',
    accentTile: 'var(--shadow-accent-tile)',
    contentLift: 'var(--shadow-content-lift)',
    mascot: 'var(--shadow-mascot)',
  },
  space: {
    smallXxs: 'var(--space-small-xxs)',
    smallXs: 'var(--space-small-xs)',
    smallS: 'var(--space-small-s)',
    smallM: 'var(--space-small-m)',
    smallL: 'var(--space-small-l)',
    mediumXs: 'var(--space-medium-xs)',
    mediumS: 'var(--space-medium-s)',
    mediumM: 'var(--space-medium-m)',
    mediumL: 'var(--space-medium-l)',
    largeXs: 'var(--space-large-xs)',
    largeS: 'var(--space-large-s)',
    largeM: 'var(--space-large-m)',
    largeL: 'var(--space-large-l)',
  },
  radii: {
    card: 'var(--radius-card)',
    row: 'var(--radius-row)',
    tile: 'var(--radius-tile)',
    chip: 'var(--radius-chip)',
    menu: 'var(--radius-menu)',
    sheet: 'var(--radius-sheet)',
    button: 'var(--radius-button)',
    sm: 'var(--radius-sm)',
    xs: 'var(--radius-xs)',
    round: 'var(--radius-round)',
    pill: 'var(--radius-pill)',
  },
  motion: {
    durationTap: 'var(--duration-tap)',
    durationFast: 'var(--duration-fast)',
    durationNormal: 'var(--duration-normal)',
    durationDrift: 'var(--duration-drift)',
    durationHero: 'var(--duration-hero)',
    easingStandard: 'var(--easing-standard)',
    easingOut: 'var(--easing-out)',
    easingInOut: 'var(--easing-in-out)',
  },
  zIndex: {
    background: 'var(--z-background)',
    content: 'var(--z-content)',
    header: 'var(--z-header)',
    floating: 'var(--z-floating)',
    menu: 'var(--z-menu)',
    overlay: 'var(--z-overlay)',
    sheet: 'var(--z-sheet)',
    modal: 'var(--z-modal)',
    toast: 'var(--z-toast)',
  },
} as const

export type Tokens = typeof tokens

export const TYPOGRAPHY_ROLES = [
  'DISPLAY',
  'H1',
  'H2',
  'H3',
  'BODY',
  'BODY_L',
  'BODY_S',
  'CAPTION',
  'MICRO',
  'OVERLINE',
  'TAB',
  'HERO_PERCENT',
] as const

export type TypographyRole = (typeof TYPOGRAPHY_ROLES)[number]
